import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
} from '@kirz/mui-admin';
import { Button } from '@mui/material';
import React, {
  forwardRef,
  Ref,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

export const ClientFormsTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, ...rest } = props;
    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          {
            field: 'name',
            headerName: 'Naam',
            selector: 'publicId name extension',
            flex: 1,
          },
          { field: 'deadline', headerName: 'Deadline', type: 'date' },
          { field: 'filledAt', headerName: 'Gevuld op', type: 'date' },
          {
            field: 'open',
            headerName: '',
            selector: false,
            sortable: false,
            width: 150,
            renderCell: (params) => {
              return (
                <Button
                  variant="contained"
                  size="small"
                  component="a"
                  href={`/forms/${params.row.slug}`}
                  target="_blank"
                >
                  Open
                </Button>
              );
            },
            flex: 1,
          },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="webForm"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        editable={{
          icon: 'eye',
          onEdit(row) {
            window.open(`/forms/${row.slug}`, '_blank');
          },
        }}
        deletable={false}
        disableRemovedFilter
        selectProps={{
          ...rest.selectProps,
          onSelection() {
            return [
              `id
              name
              slug
              deadline
              clients {
                isFilled
                filledAt
              }`,
            ];
          },
          onFetch(items) {
            return items.map((item) => {
              const client = item.clients[0];
              return {
                ...item,
                name: item.name,
                slug: item.slug,
                deadline: item.deadline,
                isFilled: client?.isFilled,
                filledAt: client?.filledAt,
              };
            });
          },
        }}
      />
    );
  },
);
